import { defineComponent, reactive, ref, watch } from "vue";
import store from "@/store";
import IsvStep1 from "@/assets/video/isv/step1.mp4";
import IsvStep2 from "@/assets/video/isv/step2.mp4";
import NormalStep2 from "@/assets/video/normal/step2.mp4";
import NormalStep1 from "@/assets/video/normal/step1.mp4";
import ContactUs from "@/components/layout/content/ContactUs.vue";
export default defineComponent({
  name: "GuideDialog",
  components: {
    ContactUs
  },
  setup() {
    const state = reactive({
      guideVisible: false,
      isISV: false,
      step1: "",
      step2: "",
      activeIndex: 0
    });
    const carouselDom = ref();
    watch(() => store.state.guideDialogVisible, newValue => {
      state.guideVisible = newValue;
    }, {
      immediate: true
    });
    watch(() => store.state.userInfo.identityType, newIdentityType => {
      state.isISV = newIdentityType === "1";
      if (newIdentityType === "1") {
        state.step1 = IsvStep1;
        state.step2 = IsvStep2;
      } else {
        state.step1 = NormalStep1;
        state.step2 = NormalStep2;
      }
    }, {
      deep: true,
      immediate: true
    });
    const handleChange = index => {
      state.activeIndex = index;
    };
    const handlePre = () => {
      if (state.activeIndex > 0) {
        carouselDom.value && carouselDom.value.prev();
        state.activeIndex -= 1;
      }
    };
    const handleNext = () => {
      if (state.activeIndex < 2) {
        carouselDom.value && carouselDom.value.next();
        state.activeIndex += 1;
      }
    };
    const handleMore = () => {
      window.open("https://cloud.jdl.com/#/open-business-document/access-guide/157/54842", "__blank");
    };
    const handleClose = () => {
      store.commit("setGuideDialogVisible", false);
    };
    return {
      state,
      carouselDom,
      handleChange,
      handlePre,
      handleNext,
      handleMore,
      handleClose
    };
  }
});